import { Routes } from '@angular/router';
import { atAuthGuard, atGuestOnlyGuard } from '@anothertrip/anothertrip-ds';

import { SUBSCRIPTION_ROUTES } from './features/subscription/subscription.routes';
import { deepLinkAuthGuard } from './guards/deep-link-auth.guard';
import { PageNotFoundPage } from './pages/page-not-found/page-not-found.page';
import { AUTH_ROUTES } from './routes/auth.routes';

export const routes: Routes = [
  // Default landing: the personalized Home dashboard.
  {
    path: '',
    redirectTo: '/dashboard/home',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./layouts/full-width/full-width.layout').then((c) => c.FullWidthLayout),
    children: [
      {
        path: 'page-not-found',
        title: 'Page not found',
        component: PageNotFoundPage,
      },
      {
        path: 'subscription',
        loadComponent: () =>
          import('./features/subscription/layouts/subscription.layout').then((c) => c.SubscriptionLayout),
        canActivate: [atAuthGuard],
        canActivateChild: [atAuthGuard],
        children: SUBSCRIPTION_ROUTES,
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./layouts/auth/auth.layout').then((c) => c.AuthLayout),
    canActivate: [atGuestOnlyGuard],
    children: AUTH_ROUTES,
  },
  {
    path: '',
    loadComponent: () => import('./layouts/default/default.layout').then((c) => c.DefaultLayout),
    children: [
      {
        path: 'terms-of-use',
        title: 'Terms of use',
        loadComponent: () => import('./pages/terms-of-use/terms-of-use.page').then((c) => c.TermsOfUsePage),
      },
      {
        path: 'privacy-policy',
        title: 'Privacy policy',
        loadComponent: () => import('./pages/privacy-policy/privacy-policy.page').then((c) => c.PrivacyPolicyPage),
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./layouts/dashboard/dashboard.layout').then((c) => c.DashboardLayout),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.page').then((c) => c.DashboardPage),
        canActivate: [atAuthGuard],
        canActivateChild: [atAuthGuard],
        loadChildren: () => import('./routes/dashboard.routes').then((r) => r.DASHBOARD_ROUTES),
      },
      {
        path: 'profile',
        title: 'Profile',
        loadComponent: () => import('./pages/profile/profile.page').then((c) => c.ProfilePage),
        canActivate: [atAuthGuard],
      },
      {
        path: 'billing',
        title: 'Billing',
        loadComponent: () => import('./features/subscription/pages/billing/billing.page').then((c) => c.BillingPage),
        canActivate: [atAuthGuard],
      },
      {
        path: 'campaigns',
        canActivate: [atAuthGuard],
        loadChildren: () => import('./features/campaigns/routes/campaigns.routes').then((r) => r.CAMPAIGNS_ROUTES),
      },
      {
        path: 'brands',
        canActivate: [atAuthGuard],
        loadChildren: () => import('./features/brands/routes/brands.routes').then((r) => r.BRANDS_ROUTES),
      },
      {
        path: 'creator-discovery',
        canActivate: [deepLinkAuthGuard],
        loadChildren: () =>
          import('./features/creator-discovery/routes/creator-discovery.routes').then(
            (r) => r.CREATOR_DISCOVERY_ROUTES
          ),
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./layouts/full-screen/full-screen.layout').then((c) => c.FullScreenLayout),
    children: [
      {
        path: 'map/:requestId',
        title: 'Map',
        loadComponent: () => import('./features/map/pages/map/map.page').then((c) => c.MapPage),
        canActivate: [atAuthGuard],
      },
      {
        path: 'businesses-map',
        title: 'Local businesses',
        loadComponent: () =>
          import('./features/map-business/pages/map-business/map-business.page').then((c) => c.MapBusinessPage),
        canActivate: [atAuthGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full',
  },
];
